import React, { FC } from 'react'

import MySubscriptions from './MySubscriptions'

const SubscriptionsWrapper: FC = () => {
    return (
        <>

            <MySubscriptions />
        </>
    )
}

export default SubscriptionsWrapper;
